export default "__VITE_ASSET__78776b77__"